module.exports = __webpack_public_path__ + "img/3a2c2e5.png";